<template>
  <Form
    v-if="settlementSheet"
    :form-id="formId"
    :initial-values="settlementSheet"
    action="#"
    class="bold section"
    :class="{ dirty }"
  >
    <HiddenInput input-id="id" />
    <div class="pb-3">
      <VPInput
        :disabled="loading"
        input-id="businessName"
        label="Business name"
        placeholder="Add business name"
      />
    </div>
    <div class="pb-3">
      <VPInput
        :disabled="loading"
        input-id="taxId"
        label="Tax id"
        placeholder="Add tax id"
      />
    </div>
    <div class="pb-3">
      <div class="row-label">
        Address
      </div>
      <FieldsFor name="address">
        <VPAddressInput
          :disabled="loading"
          @change="onAddressChange"
        />
      </FieldsFor>
    </div>

    <div class="pb-3">
      <div class="row-label pb-2">
        Tax withholding
      </div>
      <div class="flex">
        <div :class="{ 'has-value': taxesHaveType }">
          <VPDropdown
            input-id="taxWithholdingType"
            placeholder="Choose taxes type"
            :options="taxesTypeOptions"
            @change="onTypeChange"
          />
        </div>
        <div class="pl-3 flex-1">
          <component
            :is="taxesHaveType === 'FIXED' ? VPPriceInput : VPPercentageInput"
            :disabled="loading"
            input-id="taxWithholdingAmount"
            placeholder="Add amount"
            class="text-left"
          />
        </div>
      </div>
    </div>
  </Form>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { FieldsFor, Form, HiddenInput, useFormsStore } from 'vuniform';
import VPInput from '@/components/form/VPInput.vue';
import VPPriceInput from '@/components/form/VPPriceInput.vue';
import VPPercentageInput from '@/components/form/VPPercentageInput.vue';
import VPDropdown from '@/components/form/VPDropdown.vue';
import VPAddressInput from '@/components/form/VPAddressInput.vue';
import { useSettlementSheetStore } from '@/stores/settlement-sheet';
import { SettlementTaxWithholdingTypeEnum, UpdateEventArtistSettlementInput } from '../../generated/graphql';

const formId = 'settlement-taxes-form';

const formsStore = useFormsStore();
const settlementSheetStore = useSettlementSheetStore();

const settlementSheet = computed(() => settlementSheetStore.settlementSheet);
const loading = computed(() => settlementSheetStore.settlementSheetLoading);
const taxesHaveType = computed(() => formsStore.fieldGetValue(formId, 'taxWithholdingType'));

const taxesTypeOptions = [
  {
    name: '$',
    value: SettlementTaxWithholdingTypeEnum.Fixed,
  },
  {
    name: '%',
    value: SettlementTaxWithholdingTypeEnum.Percentage,
  },
];

const onAddressChange = async () => {
  if (loading.value || !formsStore.isFormDirty(formId)) {
    return;
  }

  const payload = formsStore.formGetValues<UpdateEventArtistSettlementInput>(formId);
  payload.clientMutationId = formId;

  const settlement = await settlementSheetStore.saveAddress(payload.address!);

  formsStore.SET_INITIAL_VALUES({
    values: { ...settlement },
    formId: formId,
    clearDirty: true,
  });

  formsStore.RESET_FIELD_VALUES(formId);
};
</script>
